import { BrowserRouter as Router } from "react-router-dom";
import PathAwareApp from "./javascript/components/Layout/PathAwareApp";

function App() {
    return (
        <Router>
            <PathAwareApp />
        </Router>
    );
}

export default App;
